import { Grid } from "@mui/material";
import Link from "next/link";
import {
  DirectoryCTAText,
  DirectoryGrid,
  DirectoryTitle,
  StyledArrow,
  StyledBar,
  TitleCTAGrid,
} from "./styles";

function AdviceArticleDirectory(props: any) {
  const { blog, ArticleContent, SimilarArticles, checkSimilar } = props || {};

  function handleOnClickScroll(
    e: React.MouseEvent<HTMLAnchorElement>,
    type: String,
    ref: any
  ) {
    e.preventDefault();

    const toSection = ref?.current;
    const toPosition =
      window.pageYOffset + toSection.getBoundingClientRect().top - 140;

    switch (type) {
      case "title":
        window.scrollTo({
          top: toPosition,
          behavior: "smooth",
        });
      case "similar":
        window.scrollTo({
          top: toPosition,
          behavior: "smooth",
        });
      default:
        return;
    }
  }

  return (
    <DirectoryGrid>
      <DirectoryTitle>IN THIS ARTICLE:</DirectoryTitle>
      <Link
        href={"#title"}
        onClick={(e) => {
          handleOnClickScroll(e, "title", ArticleContent);
        }}
        style={{
          textDecoration: "none",
          color: "currentcolor",
        }}
      >
        <TitleCTAGrid>
          <StyledBar />
          <DirectoryCTAText fontWeight={"600 !important"}>
            {blog?.attributes?.title}
          </DirectoryCTAText>
        </TitleCTAGrid>
      </Link>
      {checkSimilar && (
        <Link
          href={"#similar"}
          onClick={(e) => {
            handleOnClickScroll(e, "similar", SimilarArticles);
          }}
          style={{
            textDecoration: "none",
            color: "currentcolor",
          }}
        >
          <Grid display={"flex"} flexDirection={"row"} gap={"4px"}>
            <DirectoryCTAText>Related Articles</DirectoryCTAText>
            <StyledArrow />
          </Grid>
        </Link>
      )}
      <Link
        href={"/advice"}
        style={{
          textDecoration: "none",
          color: "currentcolor",
        }}
      >
        <DirectoryCTAText>Back to list</DirectoryCTAText>
      </Link>
    </DirectoryGrid>
  );
}

export default AdviceArticleDirectory;
